import { createStore, type StoreApi } from "zustand/vanilla";

export interface PrototypeDOMElement {
  pid: string;
  element: Element;
  visible: boolean;
}

export interface PrototypeDOMState {
  elements: PrototypeDOMElement[];
  addElement(pid: string, el: Element): void;
  removeElement(pid: string): void;
  clear(): void;
  setVisible(pid: string, visible: boolean): void;
}

let _store: StoreApi<PrototypeDOMState> | null = null;

export function getPrototypeDOMStore(): StoreApi<PrototypeDOMState> {
  if (!_store) {
    _store = createStore<PrototypeDOMState>((set) => ({
      elements: [],
      clear() {
        set(() => ({
          elements: [],
        }));
      },
      addElement(pid, el) {
        set((state) => ({
          elements: [
            ...state.elements.filter((e) => e.pid !== pid),
            { pid, element: el, visible: false },
          ],
        }));
      },
      removeElement(pid) {
        set((state) => ({
          elements: state.elements.filter((e) => e.pid !== pid),
        }));
      },
      setVisible(pid, visible) {
        set((state) => {
          const entry = state.elements.find((e) => e.pid === pid);
          if (!entry || entry.visible === visible) return state;
          return {
            elements: state.elements.map((e) =>
              e.pid === pid ? { ...e, visible } : e
            ),
          };
        });
      },
    }));
  }
  return _store;
}
